import script from "./Admin.vue?vue&type=script&setup=true&lang=ts"
export * from "./Admin.vue?vue&type=script&setup=true&lang=ts"

import "./Admin.vue?vue&type=style&index=0&id=20e5437c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20e5437c"]])

export default __exports__